<template>
    
    <li class="cursor-pointer d-flex gap-1 align-items-center" :class="textColorClasses">
        <i v-if="icon" :class="icon"></i>
        <span>{{ text }}</span>
    </li>

</template>

<script>
    export default {
        props: {
            icon: {
                type: String
            },
            text: {
                type: String
            }, 
            active:{
                type: Boolean,
                default: false
            },
            textColor:{
                type: String
            }
        },
        computed: {
            textColorClasses() {

                return {
                    'text-info'          : this.textColor == 'info',
                    'text-danger'        : this.textColor == 'danger',
                    'text-success'       : this.textColor == 'success',
                    'text-warning'       : this.textColor == 'warning',
                    'active'             : this.active
                };

            },
        },
    }
</script>